module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal state_caution fade bs-example-modal-sm new-model",
    class: {
      'state_true': _vm.trueFlag, 'state_false': _vm.falseFlag
    },
    attrs: {
      "id": "one",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "mySmallModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content content_size"
  }, [_c('div', {
    staticClass: "modal-body body_modal_size text-center"
  }, [_c('div', {
    staticClass: "modal_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "state_text_box"
  }, [_c('span', {
    staticClass: "state_text"
  }), _vm._v(" "), _c('span', {
    staticClass: "state_text1",
    domProps: {
      "textContent": _vm._s(_vm.tipMsg)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "btn state_btn",
    attrs: {
      "id": "btnSub",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.trueBtn
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2f69bee2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/tip.vue
// module id = 1244
// module chunks = 1